export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20layered%20translucent%20shapes%20in%20warm%20coral%20terracotta%20and%20soft%20sand%20tones%2C%20modern%20minimalist%20digital%20art%20style%2C%20smooth%20gradient%20curves%20intersecting%20with%20clean%20lines%2C%20sophisticated%20contemporary%20aesthetic%2C%20luxurious%20matte%20finish%2C%20elegant%20flowing%20forms%20creating%20depth%20and%20movement%2C%20suitable%20for%20hero%20background%20with%20ample%20negative%20space&width=1920&height=1080&seq=mulebuy-hero-main-v2&orientation=landscape"
          alt="Mulebuy Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 w-full pt-16 md:pt-0">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/80 overflow-hidden bg-secondary-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20warm%20smile%20wearing%20casual%20linen%20shirt%2C%20outdoor%20golden%20hour%20natural%20backlight%2C%20shallow%20depth%20of%20field%2C%20friendly%20approachable%20expression%2C%20clean%20portrait%20photography%20style&width=100&height=100&seq=mulebuy-avatar-hero-v2-a&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/80 overflow-hidden bg-secondary-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle%20aged%20woman%20with%20confident%20smile%20wearing%20earth%20tone%20blazer%2C%20studio%20portrait%20with%20soft%20Rembrandt%20lighting%2C%20warm%20genuine%20expression%2C%20clean%20corporate%20photography%20style&width=100&height=100&seq=mulebuy-avatar-hero-v2-b&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/80 overflow-hidden bg-secondary-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20woman%20with%20bright%20genuine%20laugh%20wearing%20minimalist%20white%20top%2C%20airy%20natural%20window%20light%2C%20fresh%20clean%20portrait%2C%20joyful%20candid%20expression%2C%20lifestyle%20photography%20style&width=100&height=100&seq=mulebuy-avatar-hero-v2-c&orientation=squarish"
                    alt="User avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/80 text-sm md:text-base font-medium">Trusted by 2,000+ users</span>
            </div>

            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
              Mulebuy<br />
              <span className="font-light">Spreadsheet</span>
            </h1>

            <p className="text-white/70 text-lg md:text-xl mt-6 max-w-xl leading-relaxed">
              Streamline your product sourcing with the ultimate Mulebuy spreadsheet system. Compare, organize, and scale — all in one place.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                Mulebuy Spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full border-2 border-white/30 text-white font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-end">
            <p className="text-white/60 text-base md:text-lg max-w-md leading-relaxed text-right hidden lg:block">
              The structured approach to managing product categories, supplier comparisons, and sourcing workflows — <strong className="text-white/90">all powered by the Mulebuy spreadsheet</strong> methodology.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}